var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6583)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6583)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_6583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.455 52.2556C57.5122 52.2556 56.6079 52.6302 55.9412 53.2969C55.2745 53.9636 54.8999 54.8679 54.8999 55.8108C54.8999 56.7536 55.2745 57.6579 55.9412 58.3246C56.6079 58.9913 57.5122 59.3659 58.455 59.3659C59.3979 59.3659 60.3022 58.9913 60.9689 58.3246C61.6356 57.6579 62.0102 56.7536 62.0102 55.8108C62.0102 54.8679 61.6356 53.9636 60.9689 53.2969C60.3022 52.6302 59.3979 52.2556 58.455 52.2556Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8645 48.108C41.8645 46.4711 43.1918 45.1454 44.8271 45.1454H72.0832C73.7186 45.1454 75.0458 46.4726 75.0458 48.108V63.5136C75.0458 65.1506 73.7186 66.4762 72.0832 66.4762H44.8271C44.4381 66.4762 44.0528 66.3996 43.6934 66.2507C43.3339 66.1018 43.0073 65.8836 42.7322 65.6085C42.4571 65.3334 42.2389 65.0068 42.09 64.6474C41.9411 64.2879 41.8645 63.9027 41.8645 63.5136V48.108ZM52.5299 55.8108C52.5299 54.2393 53.1542 52.7322 54.2654 51.621C55.3766 50.5098 56.8837 49.8856 58.4552 49.8856C60.0266 49.8856 61.5337 50.5098 62.6449 51.621C63.7561 52.7322 64.3804 54.2393 64.3804 55.8108C64.3804 57.3823 63.7561 58.8894 62.6449 60.0006C61.5337 61.1118 60.0266 61.7361 58.4552 61.7361C56.8837 61.7361 55.3766 61.1118 54.2654 60.0006C53.1542 58.8894 52.5299 57.3823 52.5299 55.8108ZM69.1206 54.6258C68.8063 54.6258 68.5049 54.7506 68.2826 54.9729C68.0604 55.1951 67.9356 55.4965 67.9356 55.8108V55.8235C67.9356 56.4776 68.4665 57.0085 69.1206 57.0085H69.1332C69.4475 57.0085 69.749 56.8837 69.9712 56.6614C70.1934 56.4392 70.3183 56.1378 70.3183 55.8235V55.8108C70.3183 55.4965 70.1934 55.1951 69.9712 54.9729C69.749 54.7506 69.4475 54.6258 69.1332 54.6258H69.1206ZM46.6047 55.8108C46.6047 55.4965 46.7295 55.1951 46.9518 54.9729C47.174 54.7506 47.4754 54.6258 47.7897 54.6258H47.8024C48.1167 54.6258 48.4181 54.7506 48.6403 54.9729C48.8626 55.1951 48.9874 55.4965 48.9874 55.8108V55.8235C48.9874 56.1378 48.8626 56.4392 48.6403 56.6614C48.4181 56.8837 48.1167 57.0085 47.8024 57.0085H47.7897C47.4754 57.0085 47.174 56.8837 46.9518 56.6614C46.7295 56.4392 46.6047 56.1378 46.6047 55.8235V55.8108Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_75_6583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0106 60.7696C71.7401 60.6189 71.427 60.5631 71.1211 60.611C70.8152 60.6589 70.5341 60.8078 70.3227 61.034L70.3222 61.0345L62.9994 68.8804C62.9993 68.8805 62.9992 68.8806 62.9991 68.8807C62.8148 69.0781 62.6921 69.325 62.6462 69.5912C62.6002 69.8575 62.6331 70.1314 62.7407 70.3792L63.5328 70.0353L62.7407 70.3792C62.8484 70.6271 63.0261 70.8381 63.252 70.9863C63.4779 71.1346 63.7423 71.2135 64.0125 71.2135H64.0126H67.9509L66.8597 75.2138C66.8596 75.2142 66.8595 75.2146 66.8594 75.2149L71.8179 61.7779L72.6136 61.4426C72.4934 61.1572 72.2811 60.9203 72.0106 60.7696ZM72.0106 60.7696L71.5903 61.5239L72.0102 60.7694C72.0103 60.7695 72.0105 60.7696 72.0106 60.7696ZM72.6737 62.3454L72.6739 62.3446L67.6923 75.4428C67.6612 75.5556 67.6689 75.6756 67.7141 75.7835C67.7594 75.8915 67.8395 75.9812 67.9417 76.0382C68.0439 76.0952 68.1622 76.1164 68.2778 76.0982C68.3935 76.08 68.4996 76.0236 68.5794 75.9379L69.2107 76.5271L69.211 76.5267C69.2111 76.5266 69.2112 76.5265 69.2113 76.5264L76.5335 68.6812C76.5336 68.6811 76.5337 68.681 76.5338 68.6809C76.7181 68.4835 76.8408 68.2366 76.8867 67.9704C76.9326 67.7041 76.8998 67.4302 76.7921 67.1824C76.6845 66.9345 76.5068 66.7235 76.2809 66.5753C76.0549 66.427 75.7906 66.3481 75.5204 66.3481H75.5203H71.5819L72.6737 62.3454Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 1.727
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6882 212.625C28.7687 212.625 30.4876 211.062 30.4876 208.495C30.4876 206.531 29.2375 205.147 26.6927 204.857V204.7C28.9696 204.432 29.9518 203.115 29.9518 201.352C29.9518 198.986 28.233 197.669 25.3756 197.669H17.0045V212.625H25.6882ZM19.3931 199.834H25.1078C26.782 199.834 27.5633 200.481 27.5633 201.888C27.5633 203.294 26.715 203.941 25.0408 203.941H19.3931V199.834ZM19.3931 205.928H25.4203C27.1838 205.928 28.0767 206.598 28.0767 208.16C28.0767 209.79 27.2061 210.46 25.4203 210.46H19.3931V205.928ZM34.4599 200.236V197.669H32.049V200.236H34.4599ZM34.4599 212.625V201.53H32.049V212.625H34.4599ZM39.1032 212.625V197.669H36.6923V212.625H39.1032ZM43.7466 212.625V197.669H41.3357V212.625H43.7466ZM51.2249 212.848C54.3501 212.848 56.4038 211.62 56.4038 209.544C56.4038 207.714 55.1984 206.821 52.5643 206.486L49.9972 206.129C48.3229 205.906 47.8765 205.593 47.8765 204.723C47.8765 203.673 48.5908 203.227 50.6222 203.227C53.0777 203.227 53.7474 203.919 53.7474 205.236V205.37H56.136V205.303C56.136 202.669 54.0823 201.307 50.6892 201.307C47.2738 201.307 45.5102 202.691 45.5102 204.633C45.5102 206.486 46.7826 207.379 48.881 207.647L51.9169 208.049C53.5019 208.272 54.0376 208.562 54.0376 209.477C54.0376 210.46 53.3902 210.906 51.2249 210.906C48.9033 210.906 48.0327 210.437 48.0327 208.986V208.808H45.6219V208.875C45.6219 211.442 47.6532 212.848 51.2249 212.848ZM64.3691 216.42V209.5H64.4584C64.9049 211.531 66.5121 212.848 69.0123 212.848C72.4723 212.848 74.3698 210.527 74.3698 207.089C74.3698 203.651 72.4277 201.307 68.99 201.307C66.3782 201.307 64.8156 202.557 64.3691 204.611H64.1682V201.53H61.9582V216.42H64.3691ZM64.3691 207.267V207.067C64.3691 204.678 65.7531 203.517 68.231 203.517C70.5526 203.517 71.9589 204.41 71.9589 207.089C71.9589 209.745 70.5749 210.661 68.1863 210.661C65.8201 210.661 64.3691 209.544 64.3691 207.267ZM79.3 212.848C81.8225 212.848 83.586 211.732 84.1664 209.857H84.3227V212.625H86.5327V205.883C86.5327 203.227 84.9477 201.307 81.4207 201.307C77.8937 201.307 75.7953 203.205 75.7953 205.727V205.817H78.1839V205.727C78.1839 204.098 79.1884 203.428 81.2421 203.428C83.3628 203.428 84.1664 204.075 84.1664 205.906V206.553L79.1214 207.089C76.9338 207.334 75.5498 208.227 75.5498 209.946C75.5498 211.777 77.0008 212.848 79.3 212.848ZM77.9607 209.79C77.9607 208.919 78.5634 208.629 79.8135 208.473L84.1664 207.982C84.1664 210.169 82.4699 211.107 79.9474 211.107C78.5634 211.107 77.9607 210.683 77.9607 209.79ZM90.4706 216.42C92.7475 216.42 93.9976 215.817 94.9128 213.83L100.694 201.53H98.0381L95.4263 207.401L94.3771 210.08H94.1985L93.1047 207.424L90.2697 201.53H87.5686L93.0377 212.625L92.7698 213.205C92.435 213.964 92.0332 214.232 91.051 214.232H88.8856V216.42H90.4706ZM104.284 212.625V207.134C104.284 204.678 105.11 203.473 107.499 203.473C109.642 203.473 110.49 204.41 110.49 206.598V212.625H112.879V207.134C112.879 204.678 113.727 203.473 116.093 203.473C118.236 203.473 119.107 204.41 119.107 206.598V212.625H121.495V205.95C121.495 203.272 120.044 201.307 117.165 201.307C114.352 201.307 113.102 203.071 112.812 204.968H112.678C112.365 202.848 111.004 201.307 108.481 201.307C105.713 201.307 104.508 203.026 104.217 204.879H104.084V201.53H101.874V212.625H104.284ZM129.232 212.848C132.536 212.848 134.858 211.219 134.858 208.852V208.652H132.447V208.83C132.447 210.147 131.487 210.906 129.165 210.906C126.598 210.906 125.549 209.768 125.46 207.625H134.88C134.947 207.29 134.969 206.977 134.969 206.575C134.969 203.205 132.625 201.307 129.188 201.307C125.571 201.307 123.205 203.629 123.205 207.089C123.205 210.795 125.594 212.848 129.232 212.848ZM129.143 203.205C131.509 203.205 132.692 204.187 132.692 206.241V206.285H125.482C125.616 204.299 126.687 203.205 129.143 203.205ZM139.186 212.625V207.134C139.186 204.723 140.28 203.473 142.713 203.473C145.012 203.473 145.95 204.522 145.95 206.598V212.625H148.361V205.95C148.361 203.383 146.843 201.307 143.762 201.307C140.949 201.307 139.476 203.093 139.141 204.968H138.985V201.53H136.775V212.625H139.186ZM157.786 212.625V210.46H155.777C154.393 210.46 153.768 210.103 153.768 208.741V203.54H157.786V201.53H153.768V199.097H151.379V201.53H149.504V203.54H151.379V208.875C151.379 211.576 152.853 212.625 155.241 212.625H157.786Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6583",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6583",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6583",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6583",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6583",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6583",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6583",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6583",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6583",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6583",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6583",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6583",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6583"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_6583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 39.625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_75_6583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.7386,
    height: 16.7386,
    fill: "white",
    transform: "translate(61.3972 59.366)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact7);
export default __webpack_public_path__ + "static/media/bigcontact7.e2301e154ba4d9fcb1f2bb71bd7fd6ea.svg";
export { ForwardRef as ReactComponent };